import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import LogoTitle from '../../assets/images/logo-s.gif'
import Logo from './Logo'
import './index.scss'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = ['h', 'o', 'm', 'a', 's', ' ', 'A', 'm', 'a', 'n', 'd', ',']
  const jobArray = [
    'a',
    'n',
    'a',
    'l',
    'y',
    's',
    't',
    'e',
    ' ',
    'p',
    'r',
    'o',
    'g',
    'r',
    'a',
    'm',
    'm',
    'e',
    'u',
    'r'
  ]

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 4000);
  
    // Fonction de nettoyage qui annule le timeout si le composant est démonté avant l'expiration du délai
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <div style={{display:"inline-block"}}>
              <img
                src={LogoTitle}
                alt="Analyste programmeur"
                style={{height:"clamp(30px, 5vw, 50px)",width:"auto",marginLeft:"0px"}} 
              />
             
              <AnimatedLetters
                letterClass={letterClass}
                strArray={nameArray}
                idx={15}
              />
            </div>
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={15}
            />
          </h1>

          <h2>Développeur Windev / Windev Mobile / Webdev</h2>
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Home
